'use strict';

var React = require('react');

const refContainsTarget = (ref, target) => !!(ref.current && target && ref.current.contains(target));
const useClickAway = ({ containerRefs, listener }) => {
    React.useEffect(() => {
        const enhancedListener = (event) => {
            if (containerRefs.every(ref => !refContainsTarget(ref, event.target)))
                listener(event);
        };
        globalThis.document?.addEventListener('mousedown', enhancedListener, { capture: true });
        globalThis.document?.addEventListener('focusin', enhancedListener, { capture: true });
        return () => {
            globalThis.document?.removeEventListener('mousedown', enhancedListener, { capture: true });
            globalThis.document?.removeEventListener('focusin', enhancedListener, { capture: true });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listener, ...containerRefs]);
};

exports.useClickAway = useClickAway;
//# sourceMappingURL=useClickAway.js.map
